import {useRef} from "react";

import {Close} from "@mui/icons-material";
import {Button, ButtonGroup, Grid, Tooltip} from "@mui/material";

import {
    Cover,
    ImageContainer,
    UploadContainer,
    CenterContainer,
    OtherImagesContainer,
    DeleteButtonContainer
} from "./_styled_components";

import {isFunction} from "lodash";
import {isNotEmpty} from "../../../shared/functions/types_check";

const ImageCard = ({url, onOpen, onDelete}) => {

    const handleOpen = () => isFunction(onOpen) && onOpen(url)

    const handleDelete = () => isFunction(onDelete) && onDelete(url)

    return (
        <Grid item xs={2}>
            <ImageContainer onClick={handleOpen} alt={'...'} src={url}/>
            <DeleteButtonContainer onClick={handleDelete}>
                <Close fontSize={'small'} color={'error'}/>
            </DeleteButtonContainer>
        </Grid>
    )
}

const ImageCardList = ({files, onAdMore, onDelete, onDeleteAll}) => {
    const hasMoreThanCover = files.length > 1;
    const [cover] = files;

    const handleDeleteAll = () => isFunction(onDeleteAll) && onDeleteAll()

    return (

        <Grid container spacing={3}>

            <Grid item xs={12}>
                <CenterContainer>

                    <Tooltip title={cover? 'Image de couverture':'Aucune image de couverture'}>
                        <Cover src={cover?.preview}/>
                    </Tooltip>

                </CenterContainer>
            </Grid>


            <Grid item xs={12}>
                <OtherImagesContainer>

                    <Tooltip title={'Toutes les images'}>
                        <Grid container spacing={2}>
                            {
                                hasMoreThanCover &&  isNotEmpty(files) && files.map(({preview}) => (
                                    <ImageCard
                                        url={preview}
                                        key={preview}
                                        onDelete={onDelete}
                                        onOpen={url => console.log(url)}
                                    />
                                ))
                            }
                        </Grid>
                    </Tooltip>

                </OtherImagesContainer>
            </Grid>


            <Grid item xs={12} justifyItems={'end'}>
                <CenterContainer>
                    <ButtonGroup>
                        <Button variant={'contained'} color={'primary'} onClick={onAdMore}>
                            Ajouter
                        </Button>
                        <Button variant={'outlined'} onClick={handleDeleteAll}>
                            Tout retirer
                        </Button>
                    </ButtonGroup>
                </CenterContainer>
            </Grid>

        </Grid>
    )
}

export default function ImagesSelection({files = [], onDrop, onRemove, onRemoveAll}) {
    const inputRef = useRef();

    const handleDrop = (acceptedFiles) => {

        let list = [];

        for (const file of acceptedFiles) {
            list.push(Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
        }

        isFunction(onDrop) && onDrop(list);
    }

    const handleAddMore = () => inputRef.current?.click()

    return (
        <UploadContainer>

            <ImageCardList
                files={files}
                onAdMore={handleAddMore}
                onDelete={onRemove}
                onDeleteAll={onRemoveAll}
            />

            <input
                type={'file'}
                accept={"image/*"}
                multiple
                hidden
                ref={inputRef}
                onChange={({target: {files}}) => handleDrop(files)}
            />

        </UploadContainer>
    )

}